import { Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Grid, GridItem } from "@chakra-ui/react"
import { format } from "date-fns";

import { getCurrencySymbol } from "@/utils/currency";
import { MONTHS_OPTION, COLORS } from "@/common/constants";
import { Form, Formik } from "formik";

export type SireReviewerPaymentDataConfirmation = {
    invoiceId: string, // internal UID
    invoiceNumber: string, // user-facing
    companyName: string,
    month: number,
    year: number,
    invoiceDate: Date | string,
    paymentDate: Date | string,
    totalReviews: number,
    currency: string, // "IDR" / "USD"
    totalAmount: number,
    downloadId: string,
}

type ModalSireReviewerInvoiceConfirmProps = {
    isOpen: boolean,
    onClose: () => void,
    handleCancel: () => void,
	handleConfirm: () => Promise<void>
    dataConfirmation?: SireReviewerPaymentDataConfirmation,
    handleDownload: (downloadId: string) => void,
}

const ModalSireReviewerPaymentConfirm = ({ isOpen, onClose, handleCancel, handleConfirm, dataConfirmation, handleDownload }: ModalSireReviewerInvoiceConfirmProps) => {
    return (
        <Modal onClose={onClose} isOpen={isOpen} isCentered size='xl'>
            <ModalOverlay />
				<Formik initialValues={{ dummy: "" }}
					onSubmit={async () => {
						await handleConfirm()
					}}>
					{formik => (
						<Form>

            <ModalContent borderRadius={15} padding={'10px'}>
								<ModalHeader>Payment Approvalss</ModalHeader>
                <ModalCloseButton onClick={handleCancel} _focus={{ outline: 'none', boxShadow: 'none' }} />
                <ModalBody marginTop={5}>
                    <Grid templateColumns='repeat(2, 1fr)' gap={6}>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Invoice ID</p>
                            <p>{dataConfirmation?.invoiceNumber ?? '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Invoice Date</p>
                            <p>{dataConfirmation?.invoiceDate ? format(dataConfirmation?.invoiceDate, 'dd-MM-yyyy') : '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Review Month</p>
                            <p>{dataConfirmation?.month && dataConfirmation?.year ? (MONTHS_OPTION[dataConfirmation.month] + ' ' + dataConfirmation.year) : '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Payment Date</p>
                            <p>{dataConfirmation?.paymentDate ? format(dataConfirmation?.paymentDate, 'dd-MM-yyyy') : '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Total SIRE Reviews</p>
                            <p>{dataConfirmation?.totalReviews ?? '-'}</p>
                        </GridItem>
                        <GridItem w='100%'>
                            <p style={{ fontWeight: 'bold' }}>Amount</p>
                            <p>{dataConfirmation?.currency ? getCurrencySymbol(dataConfirmation.currency, dataConfirmation.totalAmount) : '-'}</p>
                        </GridItem>
                    </Grid>
                    {(dataConfirmation?.downloadId) && <div style={{ width: '100%', marginTop: 30, marginBottom: 20 }}>
                        <p style={{ fontWeight: 'bold', marginBottom: 5 }}>Proof of Payment</p>
                        <Button onClick={() => handleDownload(dataConfirmation?.downloadId)} style={{ width: '100%' }}>Download</Button>
                    </div>}

                </ModalBody>
                <ModalFooter style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: 10 }}>
									<Button type="button" disabled={formik.isSubmitting} onClick={handleCancel} borderColor='#D0D5DD' bgColor='white'>Cancel</Button>
									<Button type="submit" disabled={formik.isSubmitting} isLoading={formik.isSubmitting} loadingText="Confirming" bgColor={COLORS.BUTTON.BACKGROUND} color={COLORS.BUTTON.FOREGROUND}>Confirm</Button>
                </ModalFooter>
            </ModalContent>
						</Form>
					)}
				</Formik>
        </Modal>
    )
}

export default ModalSireReviewerPaymentConfirm;